import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from '@/lang';

const DEFAULT_POSITION = 'bottom';
const DEFAULT_TIMEOUT = 3000;

const TYPE_DEFAULTS = {
  positive: { color: 'green', icon: 'check' },
  negative: { color: 'red', icon: 'error' },
  info: { color: 'blue', icon: 'info' },
  warning: { color: 'orange', icon: 'warning' },
};

export const notify = ({
  messageKey,
  messageParams = {},
  type = 'positive',
  color,
  icon,
  timeout = DEFAULT_TIMEOUT,
  position = DEFAULT_POSITION,
}) => {
  const defaults = TYPE_DEFAULTS[type] || {};
  const message =
    typeof messageKey === 'string'
      ? i18n.global.t(messageKey, messageParams)
      : messageKey;

  Notify.create({
    message,
    type,
    color: color || defaults.color,
    icon: icon || defaults.icon,
    timeout,
    position,
  });
};

export const notifySuccess = (messageKey, options = {}) =>
  notify({ messageKey, type: 'positive', ...options });

export const notifyError = (messageKey, options = {}) =>
  notify({ messageKey, type: 'negative', ...options });

export const notifyInfo = (messageKey, options = {}) =>
  notify({ messageKey, type: 'info', ...options });

export const notifyWarning = (messageKey, options = {}) =>
  notify({ messageKey, type: 'warning', ...options });


// notifyError('bookings.dialog.complete.error');
// notifySuccess('validation.minPrice', { messageParams: { min: 4 } }); 
// notifyWarning('bookings.dialog.complete.success', { color: 'primary', icon: 'event', timeout: 13000 });